'use client';

import { Box, useTheme } from '@mui/material';

import { CustomBackground } from '@/components/CustomBackground/CustomBackground';
import { FormContactUs } from '@/components/Forms/FormContactUs';
import { StrapiBackgroundOptions, StrapiDisplayOptions } from '@/lib/DisplayOptionsHelper';

interface ContactFormSectionProps {
  contactFormBackground?: StrapiBackgroundOptions;
  contactBlurb?: any;
}

export function ContactFormSection({
  contactFormBackground,
  contactBlurb,
}: ContactFormSectionProps) {
  const theme = useTheme();

  return (
    <CustomBackground
      boxProps={{
        sx: {
          maxWidth: `100%`,
          overflow: 'visible',
          ' .content-layer': {
            overflow: 'visible',
          },
        },
      }}
      containerProps={{
        sx: {
          maxWidth: `100%`,
          overflow: 'visible',
        },
      }}
      backgroundOptions={
        (contactFormBackground ??
          ({
            AnimateOrbs: false,
            BackgroundColor: 'purple-500',
            BackgroundOrbs: 'none',
            BackgroundOrbsOverflow: true,
            ContainedBackground: false,
            FadeInOutContent: false,
          } as StrapiBackgroundOptions)) as StrapiBackgroundOptions
      }
      displayOptions={
        {
          PaddingTop: 'sm',
          PaddingBottom: 'lg',
          PaddingInline: 'md',
          CenterAlignTitles: false,
          CenterAlignParagraphs: false,
          CenterAlignImages: false,
          ContentsWidth: 'standard',
        } as StrapiDisplayOptions
      }
    >
      <Box
        sx={{
          background: theme.palette.purple['800'],
          borderRadius: 15,
          color: theme.palette.common.white,
          padding: { xs: theme.spacing(6), sm: theme.spacing(4) },
          paddingInline: { xs: theme.spacing(0.5), sm: theme.spacing(4) },
          marginTop: `calc(${theme.spacing(1)} * -35)`,
          maxWidth: '45rem',
          marginInline: 'auto',
        }}
      >
        <FormContactUs
          content={{
            contactUsFormHeader: contactBlurb,
          }}
        />
      </Box>
    </CustomBackground>
  );
}
